import { LazoLogoPurpleNoLetters } from "@/components/utils/LazoLogo";
import { Colors } from "@/enums/Colors";
import User from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/User";
import { Box, BoxProps, SxProps, Typography, styled } from "@mui/material";
import UserAvatar from "../lazo-ai-chat-components/Avatar";

type Props = {
  // An object, can have anything added to it really.
  entry: { id: string | number; value: string; email?: string; lazoEmployee?: boolean };
  containerSx?: SxProps;
  boxProps?: BoxProps;
};

export function SuggestionItem({ entry, containerSx, boxProps }: Props) {
  const [firstName, lastName] = entry.value.split(" ");

  return (
    <SuggestionItemContainer key={entry.id} sx={{ ...containerSx }} {...boxProps}>
      <SuggestionAvatarContainer>
        <UserAvatar sx={SuggestionUserAvatarSx} user={{ firstName: firstName, lastName: lastName } as User} />
        <Box display="flex" flexDirection="column" justifyContent="center">
          <Typography>{entry.value}</Typography>
          <Typography fontSize="12px" sx={{ color: Colors.DARKER_DARKER_GRAY }}>
            {entry.email}
          </Typography>
        </Box>
      </SuggestionAvatarContainer>
      {entry.lazoEmployee && <LazoLogoPurpleNoLetters sxClass={{ width: "10px" }} />}
    </SuggestionItemContainer>
  );
}

const SuggestionItemContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  justifyContent: "space-between",
  backgroundColor: "white",
}));

const SuggestionAvatarContainer = styled(Box)(() => ({
  display: "flex",
  gap: "0.5rem",
  alignItems: "center",
}));

const SuggestionUserAvatarSx: SxProps = {
  width: "28px",
  height: "28px",
  minWidth: "28px",
  minHeight: "28px",
  borderRadius: "0.125rem",
  backgroundColor: "#fff",
  backgroundImage: "none",
  border: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
  color: Colors.ELEGANT_BLACK,
  fontWeight: 400,
  fontSize: "0.875rem",
};
